import { track } from '@vercel/analytics';

export const ANALYTICS_CONSENT_KEY = 'makemyresume-analytics-consent';

export function trackEvent(name, properties = {}) {
  try {
    if (window.localStorage.getItem(ANALYTICS_CONSENT_KEY) !== 'accepted') return;
    track(name, properties);
  } catch (_) {
    // Analytics should never interfere with CV creation or checkout.
  }
}

export function openAnalyticsSettings() {
  window.dispatchEvent(new Event('makemyresume-open-analytics-settings'));
}
